export const getNotificationId = ({ campaign, lineitem, reason }) =>
  `${campaign.id}_${lineitem.id}_${reason}`;
